export enum WebSocketMessageType {
  CAMPAIGN_UPDATE = 'campaignUpdate',
  MEASUREMENT_UPDATE = 'measurementUpdate',
  ALERT = 'alert',
  MAINTENANCE = 'maintenance',
  MESSAGE = 'message',
}

export interface WebSocketMessage<T = unknown> {
  type: WebSocketMessageType;
  message: T;
  title?: string;
}

export interface MeasurementUpdatePayload {
  campaignId?: number;
  campaignIds?: number[];
  measureId?: number;
  /** Pending (enqueue) frames fanning out across a campaign carry the ids of the measures
   *  actually queued, so only their rows flash "Calcul en cours" — not the whole campaign.
   *  They also name the analysis posts whose formulas reference a queued measure: their own
   *  cascade jobs only land once the engine writes the source's values, so this fan-out is
   *  the only enqueue-time signal their detail screens get. Absent on legacy/terminal frames. */
  measureIds?: number[];
  assetId: number;
  campaignMeasureIds?: number[];
  /** 'pending' = ces-api enqueue signal (flash "Calcul en cours", no refetch); 'progress' =
   *  ces-calcul resumable-pass partial result (refetch); 'completed'/'failed' = ces-calcul
   *  terminal (refetch). */
  calculationStatus?: 'completed' | 'failed' | 'progress' | 'pending';
}

export interface CampaignUpdatePayload {
  /** Single-campaign transitions carry campaignId; a bulk manual-import carries campaignIds. */
  campaignId?: number;
  campaignIds?: number[];
  assetId: number;
}
